import { analyzeField, LINKEDIN_LIMITS } from '../linkedinCounter.js';

function updateCounter() {
    const fieldKey = document.getElementById('fieldSelect').value;
    const text = document.getElementById('textInput').value;
    const result = analyzeField(text, fieldKey);

    if (!result) return;

    const barColor = result.isOver ? '#ef4444' : result.percentage > 80 ? '#f59e0b' : '#4f46e5';

    document.getElementById('charCount').textContent = result.currentLength;
    document.getElementById('charCount').style.color = result.isOver ? '#ef4444' : '#1f2937';
    document.getElementById('maxCount').textContent = result.maxLength;
    document.getElementById('remainingCount').textContent = result.isOver ? `${result.remaining} over limit!` : `${result.remaining} remaining`;
    document.getElementById('remainingCount').style.color = result.isOver ? '#ef4444' : '#059669';
    document.getElementById('progressBar').style.width = `${Math.min(result.percentage, 100)}%`;
    document.getElementById('progressBar').style.backgroundColor = barColor;

    const truncDiv = document.getElementById('truncationPreview');
    if (result.truncatedPreview) {
        truncDiv.innerHTML = `
            <p style="font-size:0.75rem;color:#d97706;font-weight:600;margin-bottom:0.5rem;">
                ⚠ LinkedIn Search will truncate at ${result.searchTruncateAt} characters:
            </p>
            <p style="font-size:0.875rem;color:#374151;background:#fffbeb;padding:1rem;border-radius:8px;border:1px solid #fde68a;">${result.truncatedPreview}</p>
        `;
    } else {
        truncDiv.innerHTML = '';
    }
}

// Update all field counters in the quick-reference table
function updateAllFields() {
    const fields = Object.keys(LINKEDIN_LIMITS);
    fields.forEach(key => {
        const el = document.getElementById(`limit-${key}`);
        if (el) el.textContent = LINKEDIN_LIMITS[key].max;
    });
}

document.getElementById('textInput').addEventListener('input', updateCounter);
document.getElementById('fieldSelect').addEventListener('change', () => {
    updateCounter();
    const field = LINKEDIN_LIMITS[document.getElementById('fieldSelect').value];
    document.getElementById('textInput').placeholder = `Type or paste your ${field.label} text here...`;
});

updateCounter();
updateAllFields();
